import React, { useEffect, useState } from "react";
import { Box, Typography, Button, CircularProgress } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { generatePDF } from "./generatePDF";

const PaymentReturn = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [paymentStatus, setPaymentStatus] = useState(null);

    // Example: Extract payment reference from query params
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const paymentRef = params.get("paymentRef");
        // Optionally: fetch payment status from backend using paymentRef
        // For now, simulate success after 1s
        setTimeout(() => {
            setPaymentStatus("success"); // or "failed"
            setLoading(false);
        }, 1000);
    }, [location.search]);

    const handleDownloadPDF = () => {
        // You need to pass the correct data here, e.g. from localStorage or backend
        // generatePDF({ logoBase64, organizationPayload, buildingsPayload, agreeConditions, agreeMandate });
    };

    return (
        <Box sx={{ mt: 6, textAlign: "center" }}>
            {loading ? (
                <CircularProgress />
            ) : paymentStatus === "success" ? (
                <>
                    <Typography variant="h4" gutterBottom>
                        Payment Successful!
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                        Thank you for your payment. Your onboarding is now complete.
                    </Typography>
                    <Button variant="contained" sx={{ mr: 2 }} onClick={handleDownloadPDF}>
                        Download Summary as PDF
                    </Button>
                    <Button variant="outlined" onClick={() => navigate("/dashboard")}>
                        Go to Dashboard
                    </Button>
                </>
            ) : (
                <>
                    <Typography variant="h4" color="error" gutterBottom>
                        Payment Failed
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                        Something went wrong with your payment. Please try again or contact support.
                    </Typography>
                    <Button variant="contained" onClick={() => navigate("/")}>
                        Return to Home
                    </Button>
                </>
            )}
        </Box>
    );
};

export default PaymentReturn;